import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from '../../models/api-resource.interface';
import { PropositionStatus } from './proposition-status.interface';

export class PropositionStatusService {
   async getPropositionStatuses(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<PropositionStatus>>>(`/proposition-statuses`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }
}
